import React, { Component } from 'react';
import {
  Grid,
  Image,
} from 'semantic-ui-react';
import walking from '../images/pedestrianInformation/walking.svg';

class PublicTransportInformation extends Component {
  render() {
    return (
      <Grid.Row style={{paddingTop: '4px', paddingBottom: '4px'}}>
        <Grid.Column width={3} />
        <Grid.Column width={13} textAlign='left'>
          <Image src={walking} height='20px' spaced='right' />
          <span className='grey'>
            {this.props.duration + 'min'}
          </span>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default PublicTransportInformation